/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  paperCardFrame: {
    marginBottom: '24px',
    borderRadius: '0px',
  },
  titleHead: {
    background: theme.palette.primary.grey,
    display: 'flex',
    padding: '16px 24px',
    borderRadius: '10px',
    '& h2': {
      color: theme.palette.primary.acscent,
      marginBottom: '0',
      fontSize: '20px',
      fontWeight: '600',
    },
  },
  Title: {
    fontWeight: '600',
    marginBottom: '5px',
    fontSize: '16px',
  },

  // contractors
  contractorsListContainer: {
    '& > $contractorContainer:not(:first-of-type)': {
      borderTop: `1px solid ${theme.palette.primary.borderColor}`,
    },
  },
  contractorContainer: {
    padding: '24px',
  },
  contractorTitle: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: '600',
    fontSize: '20px',
    lineHeight: '30px',
    marginBottom: '24px',
  },
  contractorContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  contractorImg: {
    marginRight: '16px',
    width: '64px',
    height: '64px',
  },
  contractorHeading: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '27px',
  },
  viewBtnContainer: {
    padding: '24px',
    textAlign: 'center',
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
  },
  viewBtn: {
    color: theme.palette.primary.adgmGreen,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
  },

  '@media (max-width: 768px)': {
    paperCardFrame: {
      border: '0',
      borderRadius: '0',
    },
  },
  '@media (max-width: 960px)': {
    // mdDown
    titleHead: {
      padding: '12px 16px',
      '& h2': {
        fontSize: '16px',
      },
    },
    // contractors
    contractorContainer: {
      padding: '24px 16px',
    },
    contractorTitle: {
      fontWeight: '600',
      fontSize: '16px',
      lineHeight: '22px',
      marginBottom: '24px',
    },
    contractorContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    contractorImg: {
      marginRight: '12px',
    },
    contractorHeading: {
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '20px',
    },
    viewBtnContainer: {
      padding: '16px',
    },
    viewBtn: {
      fontWeight: '500',
      fontSize: '12px',
      lineHeight: '18px',
    },
  },
});

export default styles;
